import { BaseRouteService } from "core/services";

class ConfirmingReportItemValidationRouteService extends BaseRouteService {
	constructor() {
		super("confirming-report-item-validations");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,confirmingReportItemId,salesOrderNumber,confirmingReportId}`, filter);
	}	
	
	updateValidations(resource) {
		return super.update(`${this.base}/update-validations`, resource);
	}
}

export default ConfirmingReportItemValidationRouteService;